import Rest from '@/services/Rest';

/**
 * @typedef {AvaliationService}
 */
export default class AvaliationService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/avaliation'
}
